import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import QrCode from "../../../../components/qr-code";
import {useTranslation} from "react-i18next";
import associateServices from "../../../../services";
import Loading from "../../../../components/loading";
import {useSearchParams} from "react-router-dom";
import {Tooltip} from "react-tooltip";
import CLIPBOARD_HELPER from "../../../../helpers/clipboard-helpers";
import {toast} from "react-toastify";
import InformationToast from "../../../../components/toast/InformationToast";
import Big from "big.js";
import TryDeposit from "./try-deposit/try-deposit";
import DepositCurrencyDropdown from "./currency-dropdown";
import NetworkDropdown from "../network-dropdown";
import TryPaymentMethodDropdownOld from "./try-deposit/method-dropdown";
import SvgIcon from "../../../../components/svg-icon";
import AznPaymentMethodDropdown from "./azn-deposit/method-dropdown";
import AznDeposit from "./azn-deposit/azn-deposit";


const DepositModal = () => {

    const {t} = useTranslation()
    const {
        wallets,
        selectedWallet,
        currencies,
        currencyList,
        networkSettings
    } = useSelector(state => state.authenticationReducer)
    const {
        modalCurrency,
        networks: wholeNetworks,
    } = useSelector(state => state.globalReducer)
    const [searchParams, setSearchParams] = useSearchParams()

    const [tryPaymentMethod, setTryPaymentMethod] = useState('')
    const [method, setMethod] = useState({})
    const [selectedProvider, setSelectedProvider] = useState(null)
    const [loading, setLoading] = useState(false)
    const [selectedCurrency, setSelectedCurrency] = useState({})

    const [networks, setNetworks] = useState([])
    const [theNetwork, setTheNetwork] = useState("")
    const [minAmount, setMinAmount] = useState('')

    // Handle click outside dropdown


    const [isNetworkDisabled, setIsNetworkDisabled] = useState(false)
    useEffect(() => {


        if (selectedCurrency?.code && theNetwork) {
            const item = networkSettings?.find(oo => oo.currency === selectedCurrency?.code && oo?.network?.key === theNetwork)

            setIsNetworkDisabled(!item || !item?.is_deposit)
        }
    }, [networkSettings, selectedCurrency, theNetwork])

    useEffect(() => {

        if (modalCurrency) {
            setSelectedCurrency({
                code: modalCurrency
            })
        } else if (selectedWallet?.code) {
            setSelectedCurrency({
                code: selectedWallet.code,
                address: selectedCurrency.address
            })
        }
    }, [selectedWallet, modalCurrency])

    useEffect(() => {
        if (networks?.length >= 1)
            setTheNetwork(networks[0]?.key)
    }, [networks])

    useEffect(() => {
        const instances = currencies?.filter(currency => currency.alias === selectedCurrency?.code)

        if (instances.length === 1) {
            // 1 network setTheNetwork
            setTheNetwork(instances[0].network.key)
            setNetworks([])
        } else if (instances.length >= 2) {
            setNetworks(instances?.map(currency => ({
                name: currency.network.name,
                key: currency.network.key,
            })))
        }
    }, [selectedCurrency?.code, currencies])

    useEffect(() => {
        if (selectedCurrency?.code && theNetwork) {
            const existsWallet = wallets?.find(ii => ii.code === selectedCurrency?.code && ii?.currency?.network?.key === theNetwork)

            if (existsWallet)
                return setSelectedCurrency(prevState => ({
                    ...prevState,
                    address: existsWallet.address
                }))

            setLoading(true)
            associateServices.createWallet({
                code: selectedCurrency.code,
                network: theNetwork
            }).then(res => {

                if (res?.data?.address)
                    setSelectedCurrency(prevState => ({
                        ...prevState,
                        address: res?.data?.address
                    }))

                setLoading(false)
            })
            // todo fetch wallet address by api
        }


    }, [selectedCurrency?.code, theNetwork])

    const handleChangeWallet = wall => {

        if (wall.code === selectedCurrency?.code)
            return true

        setTheNetwork('')
        searchParams.set('modal', 'wallet')
        searchParams.set('tab', 'deposit')
        searchParams.set('currency', wall.code)
        setSearchParams(searchParams)


        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setSelectedCurrency({
                code: wall.code
            })

    }
    const handleSelectNetwork = nett => {
        setTheNetwork(nett?.key)
    }

    const handleCopy = () => {
        CLIPBOARD_HELPER.copy(selectedCurrency?.address || '')

        toast(<InformationToast
            title={t('modals.wallet.deposit.copied-title')}
            message={t('modals.wallet.deposit.copied-message')}
        />)
    }


    const getValidNetwork = (basicNetwork) => {

        switch (basicNetwork) {
            case 'TRC-20':
                return 'TRON';

            case 'ERC-20':
                return 'ETHEREUM';


            case 'BEP-20':
                return 'BINANCE';

            case 'DOGE':
                return 'DOGECOIN';


            case 'LTC':
                return 'LITECOIN';


            case 'BTC':
                return 'BITCOIN';
            default:
                return basicNetwork;
        }
    }

    useEffect(() => {
        const network1 = getValidNetwork(theNetwork)
        const item = wholeNetworks?.find(i => i.network === network1)

        if (item && item?.currency) {
            const amountMin = item?.currency?.find(ii => ii.currency === selectedCurrency?.code)

            if (amountMin)
                setMinAmount(amountMin?.minDepositAmount)
        }
    }, [theNetwork, selectedCurrency?.code, wholeNetworks])

    const handleMethod = (methodMe) => {

        setMethod({...methodMe?.method, logo_light: methodMe?.logo})
        setTryPaymentMethod(methodMe?.method?.name)
        setSelectedProvider({
            id: methodMe?.provider?.id,
            name: methodMe?.provider?.name
        })
    }
    return (
        <>

            <div className="modal__drops">
                <DepositCurrencyDropdown {...{selectedCurrency, currencyList, handleChangeWallet}}/>

                {
                    selectedCurrency?.code === 'TRY' ?
                        <TryPaymentMethodDropdownOld
                            method={'deposit'}
                            tryPaymentMethod={tryPaymentMethod}
                            handleMethod={handleMethod}
                        />
                        :
                        selectedCurrency?.code === 'AZN' ?
                            <AznPaymentMethodDropdown
                                method={'deposit'}
                                tryPaymentMethod={tryPaymentMethod}
                                handleMethod={handleMethod}
                            />
                            :

                            <NetworkDropdown handleSelectNetwork={handleSelectNetwork} networks={networks}
                                             theNetwork={theNetwork}/>
                }

            </div>


            <div className="modal__form">
                {
                    loading ? <Loading/> :
                        !['TRY', 'AZN']?.includes(selectedCurrency?.code) ?
                            <>
                                {
                                    isNetworkDisabled ?
                                        <div className="form__group">

                                            <p className="form__note error text-align mt-5 mb-5">
                                                {t('modals.wallet.deposit.deposit-disabled', {
                                                    network: theNetwork,
                                                    currency: selectedCurrency.code
                                                })}
                                            </p>
                                        </div>
                                        :
                                        <div className="form__group">
                                            <label htmlFor="" className="form__label">
                                                {t('modals.wallet.deposit.your-code-deposit-address', {code: selectedCurrency.code})}
                                            </label>

                                            <div className="form__wallet">
                                                <input
                                                    value={selectedCurrency?.address || ''}
                                                    disabled={true}
                                                    type="text" className="form__input"/>
                                                <div className="form__actions">

                                                    <Tooltip className="tooltip-me" id="copy-tooltip"/>

                                                    <button type="button"
                                                            data-tooltip-id="copy-tooltip"
                                                            data-tooltip-content={'Copy'}
                                                            data-tooltip-place="top"
                                                            onClick={handleCopy}
                                                    >
                                                        <SvgIcon id={'copy'}/>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                }


                                <div className="form__group">

                                    {
                                        isNetworkDisabled ? null :
                                            <QrCode
                                                size={64}
                                                desc={t('modals.wallet.deposit.only-send', {
                                                    code: selectedCurrency?.code
                                                })}
                                                value={selectedCurrency?.address}
                                            />
                                    }

                                </div>

                            </> : null
                }

                {
                    !['TRY', 'AZN']?.includes(selectedCurrency?.code) && !isNetworkDisabled &&
                    <p className="form__description text-align w-100">
                        {t('modals.wallet.deposit.min-amount-desc', {
                            amount: Big(minAmount || 0).toFixed(8),
                            code: selectedCurrency?.code
                        })}
                    </p>

                }

            </div>

            {
                selectedCurrency?.code === 'TRY' ?
                    <TryDeposit selectedProvider={selectedProvider}
                                method={method}
                                type={tryPaymentMethod}/> :
                    selectedCurrency?.code === 'AZN' ?
                        <AznDeposit selectedProvider={selectedProvider}
                                    method={method}
                                    type={tryPaymentMethod}/> : null
            }

        </>
    )

}


export default DepositModal
